module.exports = __webpack_public_path__ + "static/media/9.f9fb720b.jpg";